angular.module("leanlaw").controller("RateChangeModalController", ["$scope", "close", "userService", "onlyUpdateEntryOptions", function ($scope, close, userService, onlyUpdateEntryOptions) {
  $scope.onlyUpdateEntryOptions = onlyUpdateEntryOptions;
  userService.me().then(me => {
    const {
      matter
    } = me.terms;
    $scope.headerText = `You are about to change billing rates; you can change rates in your
        existing matters and time entries or just in new matters going forward.
        Choose one of the three options below.`;
    $scope.radioListOptions = [{
      header: `Keep rate for existing ${matter}s`,
      content: `The new rates will apply only to new ${matter}s; existing ${matter}s and time entries maintain the same rate.`,
      value: {
        updateEntries: false,
        updateMatters: false
      }
    }, {
      header: `Change ${matter}s, Keep time entries`,
      content: `The new rates will apply to new time entries in existing and new ${matter}s. Existing time entries remain the same.`,
      value: {
        updateEntries: false,
        updateMatters: true
      }
    }, {
      header: "Change rate on everything",
      content: `The new rates will apply to new time entries in new and existing ${matter}s and to unbilled time entries in existing ${matter}s.`,
      value: {
        updateEntries: true,
        updateMatters: true
      }
    }];
    if ($scope.onlyUpdateEntryOptions) {
      $scope.radioListOptions.shift();
      $scope.headerText = `You are about to change this rate group. You can apply these changes to all existing, unbilled time entries that are using this rate group, or just to new time entries going forward. Choose one of the two options below.`;
      $scope.radioListOptions[0].header = `Keep time entries`;
      $scope.radioListOptions[1].content = `The new rates will apply to new time entries and to unbilled time entries in existing ${matter}s.`;
    }
    $scope.confirm = function () {
      close($scope.selectedAction);
    };
    $scope.reject = function () {
      close(false);
    };
  });
}]);